<app-header-inner></app-header-inner>
<!-- Subheader Start -->
<div  class="subheader dark-overlay dark-overlay-2" 
style="padding: 126px 0 2px;min-height: 211px !important;background-image: url('https://s3.eu-central-1.amazonaws.com/heek-media/images/industries/food/food-burger/cover-2.jpg')">
    
	<div class="container">
	<div class="row">
		<div class="col-12 col-md-6">
			<h1>{{res_name}}</h1>
		</div>
		<div class="col-12 col-md-6">
			<h3 style="float:right;color:white">{{myCartDateTime}}</h3>
		</div>
	</div>
      <div class="subheader-inner">
		
      </div>

    </div>
  </div>
  <!-- Subheader End -->

  <!-- Locations Wrapper Start -->
  <div class="section">

    <div class="container locations-wrapper">

      <div class="location-item">
        <div class="row">
          <div class="col-md-7 col-12 mb-4" *ngIf="noStoreFoundMessage!=''">
			<div class="sidebar-widget card p-4">
			<strong>{{noStoreFoundMessage}}</strong>
			<button (click)="openSidebar()" class="btn-custom btn-sm p-0 pt-1 pb-1 mt-2" style="box-shadow: none;width:40%">Choose different service type</button>

			</div>
          </div>
		  <div class="col-md-7 col-12 mb-4" *ngIf="noStoreFoundMessage===''">
			<div class="sidebar-widget card p-4">
			  <h5 clas="m-2">Store List</h5>
			  <hr class="m-0 p-0">
			  <article  *ngFor="let francais of francaisList; let last = last;" class="mt-4" >
				<div class="row" [ngClass]="{'location-border-bottom': last == false}">
					<div class="col-md-4 col-12">
						<img src="{{logoImage}}" style="width: 100px;">
					</div>
					<div class="col-md-4 col-7" >
					<h6> <a>{{francais.name}}</a> </h6>
					<span>{{francais.location}}</span>
					</div>
					<div class="col-md-4 col-4" *ngIf="url_store_id=='' || url_store_id==undefined">
						<div *ngIf="this.selectedFrancais==francais.id; else elseBlock">
							<i class="francais-tick fas fa-check" style="color: green;font-size: 25px;"> </i>
						</div>
						<ng-template #elseBlock> 

						<button id="francaisid_{{francais.id}}" class="francais-selectbtn btn btn-primary" 
						(click)="selectFrancais(francais.id,$event)"
						*ngIf="francais.is_open==='open'; else elseBlock"  >  
							Select
						</button>
						<ng-template #elseBlock> 
							<button class="btn btn-default" disabled>
								Select
							</button>
							<br>
							<b>Closed</b>
						</ng-template>
						</ng-template>
					</div>
					<div class="col-md-4 col-4" *ngIf="url_store_id>0">
						<button class="btn btn-default" disabled *ngIf='url_store_id!=francais.id'>
								Select
						</button>
						
						<div id="francaisid_{{francais.id}}" class="francais-selectbtn" 
						
						*ngIf="francais.is_open==='open' && url_store_id==francais.id"  >  
							<i class="francais-tick fas fa-check" style="color: green;font-size: 25px;"> </i>
						</div>
						
						<div id="francaisid_{{francais.id}}" 
						(click)="selectFrancais(francais.id,$event)"
						*ngIf="francais.is_open==='closed' && url_store_id==francais.id"  >  
							Closed
						</div>
					</div>
				</div>
				
				
			  </article>
			
			
			  
			</div>

		 </div>
          <div class="col-md-5">
            <div class="card">
                  <div class="card-header" data-toggle="collapse" role="button" data-target="#doughAccordion" aria-expanded="true" aria-controls="doughAccordion">
                     <b>Review your total</b>
                  </div>
                  <div id="doughAccordion" class="collapse show" data-parent="#variationsExample">
                    <div class="card-body p-0">
						<div *ngIf ="selectedOrderService==='Curbside'" class="customize-variation-wrapper  pt-3 m-0 pb-0" style="text-align: justify;">
						<p>Your order information and further instructions will be emailed to <a href="mailto:{{userLoginData.email}}" target="_blank">{{userLoginData.email}}.</a>   The order will come from cygnus.maiorders.com, make sure this email does not go to your junk folder</p>
						</div>
						<span></span>
						
						<div class="col-12 col-12 pb-0 customize-variation-wrapper mb-0" *ngIf = "selectedFrancaisData[0]">
							<div class="customize-variation-item " data-price="0.00">
							  <span class="pr-4" style="font-size: 22px;">{{selectedFrancaisData[0].name}}</span>
							</div>
						</div>
						
						<div class="col-12 col-12 pt-0 pb-0 customize-variation-wrapper mb-0" *ngIf = "selectedFrancaisData[0]">
							<div class="customize-variation-item " data-price="0.00">
							  <span class="pr-4" style="font-size: 14px;">{{selectedFrancaisData[0].address}}</span>
							</div>
						</div>
					    <div class="customize-variation-wrapper p-0 m-0 ">
                        <div class="customize-variation-item " data-price="0.00">
                          <div class="custom-control">
                            <label >Sub Total</label>
                          </div>
                          <span class="pr-4">${{ subtotalcart | number : '1.2-2' }}</span>
                        </div>
                      </div>
					  
					  <div class="customize-variation-wrapper p-0 m-0" *ngFor="let tax of francaisTax">
                        <div class="customize-variation-item " data-price="0.00">
                          <div class="custom-control">
                            <label >{{tax.sales_tax_desc}} ({{tax.sales_tax_percentage}}%)</label>
                          </div>
                          <span class="pr-4">${{tax.amount | number : '1.2-2'}}</span>
                        </div>
                      </div>
					<form autocomplete="off">
					  <div class="customize-variation-wrapper p-0 m-0" *ngIf="restaurantData.is_coupon==1">
                        <div class="customize-variation-item " >
                          <div class="custom-control">
							<input type="text" name="applyCoupen" id="applyCoupen" class="applyCoupen form-control auto-complete-off" placeholder="Enter Coupon Code" >
                          </div>
						  <button class="btn btn-danger p-1 mr-2 applycoupenbtn" (click)="applyCoupon()">Apply</button>
                        </div>
                      </div> 
					  </form>
					  <div class="pb-0 customize-variation-wrapper m-0" *ngIf="restaurantData.is_coupon==1">
                        <div class="customize-variation-item " >
							<button class="btn btn-primary check-coupons" (click)="checkForCoupon()"> 
							Check for Coupons </button>
						</div>
                      </div>
					  
					  <div class="pt-0 customize-variation-wrapper m-0" *ngIf="restaurantData.is_coupon==1">
                        <div class="customize-variation-item " >
							<button class="btn btn-success check-coupons" (click)="getPromoCodeList()"> 
							Apply Promo Code </button>
						</div>
                      </div>
					  <hr class="m-0">
						<div class="customize-variation-wrapper p-0 m-0 pt-3">
                        
						
						
						<div class="customize-variation-item " data-price="0.00">
                          <div class="custom-control">
                            <label >Discount</label>
                          </div>
                          <span class="pr-4">${{discountAmount }}</span>
                        </div>
						<div class="customize-variation-item " data-price="0.00" *ngIf="deliveryamount>0">
                          <div class="custom-control">
                            <label >Delivery Free</label>
                          </div>
                          <span class="pr-4">${{deliveryamount}}</span>
                        </div>
						<div class="customize-variation-item " data-price="0.00" *ngIf="is_surcharge_enabled==='1'">
                          <div class="custom-control">
                            <label >{{surcharge_label}}</label>
                          </div>
                          <span class="pr-4">${{surcharge_amount}}</span>
                        </div>
						<div class="customize-variation-item " data-price="0.00" *ngIf="enable_factor4==='1'">
                          <div class="custom-control">
                            <label >Loyalty Reward $:</label>
                          </div>
                          <span class="pr-4">${{loyalty_reward | number : '1.2-2' }}</span>
                        </div>
						<div class="customize-variation-item mb-0 pb-0 pl-3" *ngIf="enable_factor4==='1'">
						<h5 class="width-100 mb-0 pb-0">LOYALTY REWARDS</h5>
						</div>
						<div class="customize-variation-item pl-3" *ngIf="enable_factor4==='1'">
							
							<div class="card width-100 pt-0 mt-0">
								<div class="card-body m-0 p-2">
									<p >{{loyalty_reward_msg}}
									<br>
										
										<button class="btn btn-danger btn-xs float-right pl-2 ml-2" (click)="loyalityreward('no')"  *ngIf="loyalty_apply==='0'">NO</button>
										<button class="btn btn-success btn-xs float-right"  (click)="loyalityreward('yes')"  *ngIf="loyalty_apply==='0'">YES</button>
										
									</p>
								</div>	
							</div>
						</div>
						
						<div class="customize-variation-item " data-price="0.00" *ngIf="tip_amount>0">
                          <div class="custom-control">
                            <label >Tip</label>
                          </div>
                          <span class="pr-4">${{tip_amount}}</span>
                        </div>
						<div class="customize-variation-item " data-price="0.00">
                          <div class="custom-control">
                            <label >Total</label>
                          </div>
                          <span class="pr-4">${{grandTotalwithTax | number : '1.2-2' }}</span>
                        </div>
                       </div>
					   <div class="row customize-variation-wrapper m-0 pt-0 pb-0 " *ngIf="selectedFrancaisData[0]">
						<div class="col-md-12 mb-2 pl-0" *ngIf="selectedFrancaisData[0].is_tip==='1'">
							<button class="btn p-1 m-1 tip-button" id="tip-20" 
							[ngClass]="{'btn-outline-danger': selected_tip_percentage != 20, 'btn-danger':selected_tip_percentage == 20 }"
							(click)="applyTip(20)">20%</button>
							<button class="p-1 m-1 btn tip-button" id="tip-25"
								[ngClass]="{'btn-outline-danger': selected_tip_percentage != 25, 'btn-danger':selected_tip_percentage == 25 }"
								(click)="applyTip(25)">25%</button>
							<button class="p-1 m-1  btn tip-button"   id="tip-30"
							[ngClass]="{'btn-outline-danger': selected_tip_percentage != 30, 'btn-danger':selected_tip_percentage == 30 }"
							(click)="applyTip(30)">30%</button>
							<button class="p-1 m-1 btn tip-button-other" (click)="applyTip('no')"
							[ngClass]="{'btn-outline-danger': selected_tip_percentage != 'no', 'btn-danger':selected_tip_percentage ==='no' }"	
							>No Tip</button>
							<button class="btn btn-outline-danger p-1 m-1 tip-button-other"
							[ngClass]="{'btn-outline-danger': selected_tip_type != 'custom', 'btn-danger':selected_tip_type ==='custom' }"
							(click)="applyTip('custom')">Custom</button>
						</div>
					   </div>
					   <div class="customize-variation-wrapper m-0 pt-0 pb-0" >
						<div class="alert alert-danger" role="alert" *ngIf="dFeeErrorMessage!=''">
							 {{dFeeErrorMessage}}
						</div>
						</div>

						<div class="customize-variation-wrapper m-0 pt-0 " >
                        <div class="customize-variation-item " *ngIf="selectedFrancais!=0 && selectedOrderService!=''">
							<!-- routerLink='/checkout' -->
							<a   (click)="redirectCheckout()" class="text-white btn btn-success check-coupons" *ngIf="showCompleteOrderButton==='0'"> 
							Continue to Payment </a>
							
							<a   (click)="redirectCheckout()" class="text-white btn btn-success check-coupons" *ngIf="showCompleteOrderButton==='1'"> 
							Complete Order </a>
						</div>
						</div>
					  
                    </div>
                  </div>
                </div>

          </div>
        </div>
      </div>

   
      
    </div>

  </div>
  <!-- Locations Wrapper End -->
<div class="modal fade" id="loyalityreward" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="enable_factor4==='1'">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
			<h4>Account information</h4>
			<hr>
			
			<div class="row">
				<div class="col-xl-12">
					<div *ngIf="loyalityrewarderror!=''" class="alert alert-danger" role="alert">
					  <strong>Error..!!</strong> {{loyalityrewarderror}}
					</div>
				</div>
				<form style="width: 100%;" autocomplete="off">
				<div class="col-xl-12 ">
				  <label>Account #*</label>
				  <input type="text" class="form-control auto-complete-off"  name="account_number" id="account_number" value="" required >
				</div>
				</form>
				<div class="col-xl-12 ">
				  <label>Password (optional)</label>
				  <input type="text" class="form-control auto-complete-off"  name="password" id="password_account"  required autocomplete="off" style ="-webkit-text-security: disc;">
				</div>
				
				<div class="col-xl-12 ">
				  <br>
				  <input type="button" class="btn btn-block btn-success"  value="PROCEED" (click)="verfiyAccount()">
				</div>
				
            </div>
			
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal fade" id="loyalityreward-confirm" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="enable_factor4==='1'">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
			<h4 id="loyalityreward-conf-msg"></h4>
			<button class="btn btn-danger btn-xs float-right pl-2 ml-2" (click)="loyalityrewardapply('no')">NO</button>
			<button class="btn btn-success btn-xs float-right"  (click)="loyalityrewardapply('yes')">YES</button>
        </div>
      </div>
    </div>
  </div>
  
 <div class="modal fade" id="couponListModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
			<h4>Coupons List</h4>
			<hr>
			<div class="row">
              <div class="col-xl-4" *ngFor="let coupon of getCouponList">
                <div class="ct-info-box">
				<div class="row">
                <div class="col-md-8 col-8">
				  <h5 class="mb-0">{{coupon.description}}</h5>
					<span style="color:red">  {{coupon.code}}</span>
					<br>
					
					<button  class="mt-2 btn btn-success" 
					(click)="applyCouponDiscount(coupon,$event)">  
							Apply Coupon
					</button>
                
				</div>
				
				<div class="col-md-4 col-4">
					<span *ngIf="coupon.type==='percentage'"> % {{coupon.figure}}</span>
					<span *ngIf="coupon.type==='fixed'">$ {{coupon.figure}}</span>
				</div>
				</div>
				
				</div>
              </div>
            </div>
       
        </div>
      </div>
    </div>
  </div>
<div class="modal fade" id="promoCodeListModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
			<h4>Promo Code List</h4>
			<hr>
			<div class="row">
              <div class="col-xl-4" *ngFor="let promocode of promoCodeData">
                <div class="ct-info-box">
				<div class="row">
                <div class="col-md-8 col-8">
				  <h5 class="mb-0">{{promocode.promo_code}}</h5>
					<span style="color:red">  {{promocode.expiry_date}}</span>
					<br>
					<button class="mt-2 btn btn-success" (click)="applyPromoCodeDiscountCal(promocode,$event)">  
						Apply 
					</button>
               </div>
				
				<div class="col-md-4 col-4">
					<span > $ {{promocode.amount}}</span>
				</div>
				</div>
				
				</div>
              </div>
            </div>
       
        </div>
      </div>
    </div>
  </div>
<div class="modal fade" id="tip-custom" 
tabindex="-1" role="dialog" aria-hidden="true">
<div class="modal-dialog modal-md modal-dialog-centered" role="document">
  <div class="modal-content">
	<label class="p-2 m-2"><b>Add Tip <span style="color:red">(%)</span></b></label>
	<hr>
	<div class="container">
	<div class="col-md-12">
		<input type="number" class="form-control tip-custom-input" min="0" style="font-size:38px;">
		<small>Tip will be  applied in % on total amount of order</small>
	</div>
	</div>
	<div class="modal-body">
	  <button type="button" class="btn btn-block btn-success" data-dismiss="modal"  (click)="appCustomTip()" style="width: 100%;
    padding: 12px 30px;border-radius: 25px;">Apply</button>
	  <button type="button" class="btn-custom btn-block" data-dismiss="modal"  >Cancel</button>
	</div>
  </div>
</div>
</div> 
<app-footer></app-footer>